import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Textarea,
  Button,
  Alert,
  AlertIcon,
  AlertDescription,
  Text,
  Icon,
  FormHelperText,
} from "@chakra-ui/react";
import { ChatIcon } from "@chakra-ui/icons";

const NegotiationModal = ({ isOpen, onClose, place, onUpdate }) => {
  const [formData, setFormData] = useState({
    status: "in_negotiation",
    contact_notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setError(null);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    try {
      // Garantir que os tipos estejam corretos antes de enviar
      const cleanFormData = {
        ...formData,
        contact_notes: formData.contact_notes ? String(formData.contact_notes).trim() : "",
      };

      await onUpdate(cleanFormData);
      handleClose();
    } catch (error) {
      setError("Erro ao iniciar negociação");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({
        status: "in_negotiation",
        contact_notes: "",
      });
      setError(null);
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing={2}>
            <Icon as={ChatIcon} color="yellow.500" />
            <Text>Iniciar Negociação</Text>
          </HStack>
          <Text fontSize="sm" color="gray.600" mt={1}>
            {place?.title}
          </Text>
        </ModalHeader>
        <ModalCloseButton isDisabled={loading} />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            {error && (
              <Alert status="error" borderRadius="md">
                <AlertIcon />
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            <Alert status="success" borderRadius="md">
              <AlertIcon />
              <VStack align="start" spacing={1}>
                <Text fontWeight="semibold" fontSize="sm">
                  🎉 Ótimo! O cliente demonstrou interesse
                </Text>
                <AlertDescription fontSize="sm">
                  Agora você pode acompanhar a negociação e posteriormente
                  marcar como "Convertido" ou "Perdido".
                </AlertDescription>
              </VStack>
            </Alert>

            <FormControl>
              <FormLabel>Observações da Negociação</FormLabel>
              <Textarea
                placeholder="Descreva o interesse demonstrado, próximos passos, proposta enviada..."
                value={formData.contact_notes}
                onChange={(e) => handleInputChange("contact_notes", e.target.value)}
                isDisabled={loading}
                rows={5}
              />
              <FormHelperText>
                Registre detalhes importantes sobre a negociação iniciada
              </FormHelperText>
            </FormControl>

            <Alert status="info" borderRadius="md" size="sm">
              <AlertIcon />
              <AlertDescription fontSize="sm">
                <strong>Próximos passos sugeridos:</strong>
                <br />
                • Envie proposta comercial detalhada
                <br />
                • Agende reunião para apresentação
                <br />
                • Defina prazo para resposta do cliente
                <br />
                • Configure lembretes para follow-up
              </AlertDescription>
            </Alert>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack spacing={3}>
            <Button
              variant="ghost"
              onClick={handleClose}
              isDisabled={loading}
            >
              Cancelar
            </Button>
            <Button
              colorScheme="yellow"
              onClick={handleSubmit}
              isLoading={loading}
              loadingText="Iniciando..."
              leftIcon={<ChatIcon />}
            >
              Iniciar Negociação
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NegotiationModal;